import FormattedMessage from 'I18n/components/FormattedMessage';
import { CallingIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { PHONE_SUPPORT } from '../../constants/ErrorBoundaryNames';
import { ERROR_SEVERITY } from '../error-boundary/error-severity';
import withErrorBoundary from '../error-boundary/withErrorBoundary';
import CodeSplitEnvWrapper from './env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PhoneSupport = ({
  showBorder = true,
  phoneSourceId,
  screen,
  showCopy = true,
  upgradeProduct
}) => {
  const borderProps = showBorder ? {
    borderWidth: '100',
    borderStyle: 'solid',
    borderColor: 'border-core-default',
    borderRadius: '300'
  } : {};
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    children: [showCopy && /*#__PURE__*/_jsx(Text, {
      typography: "heading-100",
      "data-selenium-id": "phone-support-header",
      textAlign: "center",
      marginBlock: "200",
      marginBlockEnd: "300",
      display: "block",
      as: "h2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crm.needHelp"
      })
    }), /*#__PURE__*/_jsxs(Flex, Object.assign({
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      paddingBlock: "400",
      paddingInline: showBorder ? '1000' : '0',
      marginBlock: "0",
      marginInline: "auto"
    }, borderProps, {
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: CallingIcon,
        paddingInlineStart: "0"
      }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
        authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */'pricing-pages-ui/components/common/phone-numbers/AuthedPhoneNumber'),
        publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */'pricing-pages-ui/components/common/phone-numbers/PublicPhoneNumber'),
        authedComponentProps: {
          phoneSourceId,
          screen,
          upgradeProduct
        },
        publicComponentProps: {
          phoneSourceId,
          screen
        }
      })]
    }))]
  });
};
export default withErrorBoundary(PhoneSupport, {
  fallback: null,
  errorBoundaryName: PHONE_SUPPORT,
  severity: ERROR_SEVERITY.LOW
});